/*
 * Reviews carousel: continuous slow autoscroll + arrow navigation.
 * Loaded from layout/theme.liquid. Survives re-saves of global.js.
 */
;(function () {
  var SPEED = 28; /* px per second */
  var RESUME_DELAY = 6000;

  function initCarousel(root) {
    if (!root || root.dataset.carouselInit === "1") return;
    var track = root.querySelector(".carousel-track");
    if (!track) return;
    root.dataset.carouselInit = "1";

    var arrows = root.querySelectorAll(".nav-arrow");
    var cards = track.querySelectorAll(".review-card");
    var singleSetCount = cards.length / 2;
    var singleSetWidth = 0;

    function computeSetWidth() {
      if (singleSetCount > 0 && cards[singleSetCount]) {
        singleSetWidth = cards[singleSetCount].offsetLeft - cards[0].offsetLeft;
      }
    }
    computeSetWidth();
    window.addEventListener("resize", computeSetWidth);

    function cardStep() {
      var card = track.querySelector(".review-card");
      return card ? card.offsetWidth + 22 : 320;
    }
    function scrollByCard(direction) {
      track.scrollBy({ left: cardStep() * direction, behavior: "smooth" });
    }
    function rewindIfNeeded() {
      if (singleSetWidth > 0 && track.scrollLeft >= singleSetWidth) {
        var pb = track.style.scrollBehavior;
        track.style.scrollBehavior = "auto";
        track.scrollLeft -= singleSetWidth;
        track.style.scrollBehavior = pb;
      }
    }
    track.addEventListener("scroll", function () {
      clearTimeout(track.__rwT);
      track.__rwT = setTimeout(rewindIfNeeded, 100);
    }, { passive: true });

    var rafId = null, lastTs = null, paused = false;
    function step(ts) {
      if (lastTs !== null && !paused) {
        track.scrollLeft += ((ts - lastTs) / 1000) * SPEED;
        rewindIfNeeded();
      }
      lastTs = ts;
      rafId = requestAnimationFrame(step);
    }
    function startAuto() {
      if (rafId === null) { lastTs = null; rafId = requestAnimationFrame(step); }
    }

    root.addEventListener("mouseenter", function () { paused = true; });
    root.addEventListener("mouseleave", function () { paused = false; });
    root.addEventListener("touchstart", function () { paused = true; }, { passive: true });
    root.addEventListener("touchend", function () { setTimeout(function () { paused = false; }, RESUME_DELAY); }, { passive: true });
    root.addEventListener("mousedown", function () { paused = true; });
    root.addEventListener("mouseup", function () { setTimeout(function () { paused = false; }, RESUME_DELAY); });
    arrows.forEach(function (btn) {
      btn.addEventListener("click", function () {
        scrollByCard(parseInt(btn.dataset.direction, 10) || 1);
      });
    });
    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) startAuto();
  }

  function initAll() {
    document.querySelectorAll("[class*=custom-reviews]").forEach(initCarousel);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  new MutationObserver(initAll).observe(document.body, { childList: true, subtree: true });
})();
